import dayjs from '../../../utils/dayjsConfig'
import { DateObject } from 'react-multi-date-picker'
import 'dayjs/locale/es'

export const FILTER_KEYS = {
  client: 'CLIENTE',
  status: 'ESTADO',
  inRoute: 'DENTRO DE RUTA',
  geofence: 'DENTRO DE GEOCERCA',
  effectiveness: 'EFECTIVIDAD',
  activities: 'ACTIVIDADES'
}

export const createEmptyDateRange = () => ({
  start: null,
  end: null
})

export const buildSelectValue = (values = []) => ({
  mode: Array.isArray(values) && values.length > 0 ? 'custom' : 'all',
  values: Array.isArray(values) ? [...values] : []
})

export const createEmptyDraftFilterSelections = () => ({
  [FILTER_KEYS.client]: buildSelectValue(),
  [FILTER_KEYS.status]: buildSelectValue(),
  [FILTER_KEYS.inRoute]: buildSelectValue(),
  [FILTER_KEYS.geofence]: buildSelectValue(),
  [FILTER_KEYS.effectiveness]: buildSelectValue(),
  [FILTER_KEYS.activities]: buildSelectValue()
})

const toDayjsValue = (value) => {
  if (!value) return null
  if (dayjs.isDayjs(value)) return value.startOf('day')

  const rawValue = typeof value?.toDate === 'function' ? value.toDate() : value
  const parsed = dayjs(rawValue)

  return parsed.isValid() ? parsed.startOf('day') : null
}

export const normalizeDateRange = (range) => {
  const start = toDayjsValue(range?.start)
  const end = toDayjsValue(range?.end)

  if (!start && !end) return createEmptyDateRange()
  if (start && !end) return { start, end: null }
  if (!start && end) return { start: null, end }
  if (start.isAfter(end, 'day')) return { start: end, end: start }

  return { start, end }
}

export const buildAppliedDateRange = (range) => {
  const normalizedRange = normalizeDateRange(range)

  if (normalizedRange.start && !normalizedRange.end) {
    return {
      start: normalizedRange.start,
      end: normalizedRange.start
    }
  }

  if (!normalizedRange.start && normalizedRange.end) {
    return {
      start: normalizedRange.end,
      end: normalizedRange.end
    }
  }

  return normalizedRange
}

export const pickerValueToDateRange = (pickerValue) => {
  if (!Array.isArray(pickerValue) || pickerValue.length === 0) {
    return createEmptyDateRange()
  }

  const [firstValue, secondValue] = pickerValue

  return normalizeDateRange({
    start: firstValue,
    end: secondValue || null
  })
}

export const dateRangeToPickerValue = (range) => {
  const appliedRange = buildAppliedDateRange(range)

  if (!appliedRange.start) return null

  if (appliedRange.start.isSame(appliedRange.end, 'day')) {
    return [new DateObject(appliedRange.start.toDate())]
  }

  return [new DateObject(appliedRange.start.toDate()), new DateObject(appliedRange.end.toDate())]
}

export const dateRangeToQuery = (range, startKey, endKey) => {
  const appliedRange = buildAppliedDateRange(range)

  if (!appliedRange.start) return null

  return `&${startKey}=${appliedRange.start.format('YYYY-MM-DD')}&${endKey}=${appliedRange.end.format('YYYY-MM-DD')}`
}

export const getSelectValues = (selectValue) => {
  if (selectValue?.mode !== 'custom') return []
  return Array.isArray(selectValue.values) ? selectValue.values : []
}

export const formatDateRangeSummary = (range, emptyText = 'Sin rango seleccionado') => {
  const appliedRange = buildAppliedDateRange(range)

  if (!appliedRange.start) return emptyText

  const startLabel = appliedRange.start.locale('es').format('DD MMMM')
  const endLabel = appliedRange.end.locale('es').format('DD MMMM')

  if (appliedRange.start.isSame(appliedRange.end, 'day')) {
    return startLabel
  }

  return `${startLabel} - ${endLabel}`
}

export const buildAppliedChipLabel = ({
  singularLabel,
  pluralLabel,
  values,
  idToLabelMapping
}) => {
  if (!Array.isArray(values) || values.length === 0) return ''

  if (values.length === 1) {
    const resolvedLabel = idToLabelMapping.get(values[0]) || String(values[0])
    return `${singularLabel}: ${resolvedLabel}`
  }

  return `${pluralLabel}: ${values.length}`
}

export const countSelectedGroups = (filterSelections, plannedRange, executedRange) => {
  let selectedGroups = 0

  Object.values(FILTER_KEYS).forEach((filterKey) => {
    if (getSelectValues(filterSelections?.[filterKey]).length > 0) {
      selectedGroups += 1
    }
  })

  if (buildAppliedDateRange(plannedRange).start) {
    selectedGroups += 1
  }

  if (buildAppliedDateRange(executedRange).start) {
    selectedGroups += 1
  }

  return selectedGroups
}

export const formatDateLabel = (value) => {
  if (!value) return '-'
  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : '-'
}
